import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="ft">
      {/* Main footer */}
      <div className="ft-main">
        <div className="container">
          {/* Brand */}
          <div className="ft-brand">
            <Link to="/" className="ft-logo">
              <img src="/images/logofav.png" alt="DOMOELEC" />
              <span><span className="hdr-green">D</span>OMO<span className="hdr-green">E</span>LEC</span>
            </Link>
            <p>Solutions professionnelles en courant faible : détection incendie, éclairage de sécurité, contrôle d'accès et onduleurs.</p>
            <div className="ft-socials">
              <a href="https://www.linkedin.com/company/domoelecsarl/posts/?feedView=all" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn DOMOELEC" title="LinkedIn">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://www.youtube.com/@DOMOELEC-CFA" target="_blank" rel="noopener noreferrer" aria-label="YouTube DOMOELEC" title="YouTube">
                <i className="fab fa-youtube"></i>
              </a>
              <a href="https://www.instagram.com/domo.elec/" target="_blank" rel="noopener noreferrer" aria-label="Instagram DOMOELEC" title="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>

          <div className="ft-cols">
            {/* Links */}
            <div className="ft-col">
              <h4>Navigation</h4>
              <ul>
                <li><Link to="/">Accueil</Link></li>
                <li><Link to="/domoelec">À propos</Link></li>
                <li><Link to="/produits">Produits</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            {/* Services */}
            <div className="ft-col">
              <h4>Services</h4>
              <ul>
                <li><Link to="/services#installation">Installation</Link></li>
                <li><Link to="/services#maintenance">Maintenance</Link></li>
                <li><Link to="/services#controle">Contrôle & Vérification</Link></li>
                <li><Link to="/services#conseil">Conseil & Études</Link></li>
              </ul>
            </div>

            {/* Contact */}
            <div className="ft-col">
              <h4>Contact</h4>
              <ul className="ft-contact">
                <li>
                  <i className="fas fa-phone-alt"></i>
                  <a href="tel:0522340659">05 22 34 06 59</a>
                </li>
                <li>
                  <i className="fas fa-envelope"></i>
                  <a href="mailto:info@domoelec.ma">info@domoelec.ma</a>
                </li>
                <li>
                  <i className="fas fa-map-marker-alt"></i>
                  <span>Showroom : 47 Rue Des Orangers, Mag Res Eden Tower, Ain Sebaa - Casablanca</span>
                </li>
                <li>
                  <i className="fas fa-building"></i>
                  <span>Bureau : 2ème étage, N° 16, 80 Bd Moulay Slimane, Casablanca 20250</span>
                </li>
              </ul>
            </div>

            {/* Localisation Google Maps */}
            <div className="ft-map">
              <iframe
                src="https://maps.google.com/maps?q=DOMOELEC%2047%20Rue%20Des%20Orangers%20Ain%20Sebaa%20Casablanca%20Maroc&z=16&output=embed"
                title="DOMOELEC sur Google Maps – 47 Rue Des Orangers, Ain Sebaa, Casablanca"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
              <a
                className="ft-map-chip"
                href="https://www.google.com/maps/search/?api=1&query=DOMOELEC%2047%20Rue%20Des%20Orangers%20Ain%20Sebaa%20Casablanca%20Maroc"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-location-dot"></i>
                <span className="ft-map-chip-text">
                  <strong>Notre showroom</strong>
                  <small>47 Rue Des Orangers, Ain Sebaa – Casablanca</small>
                </span>
                <i className="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="ft-bottom">
        <div className="container">
          <div className="ft-bottom-inner">
            <p>© {new Date().getFullYear()} DOMOELEC. Tous droits réservés.</p>
            <div className="ft-bottom-links">
              <Link to="/blog">Blog</Link>
              <span className="ft-dot"></span>
              <Link to="/mentions-legales">Mentions légales</Link>
              <span className="ft-dot"></span>
              <Link to="/politique-confidentialite">Confidentialité</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
